module.exports = __webpack_public_path__ + "img/INCREMENT.3c064464.svg";